var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectShopInterstitialOffers } from "../../../selectors/selectShopInfo";
import { actionModalCloseAll } from "../../modals/actionModal";
import { ModalOverlay } from "../../modals/ModalOverlay";
import { TypeOverlayOpacity } from "../../modals/TypeOverlayOpacity";
import { actionShopRequestPurchase } from "../actionShop";
import { Shop } from "./Shop";
var _MenuShopInterstitialOffer = function (_a) {
    var onCloseClick = _a.onCloseClick, onBuyClick = _a.onBuyClick, offers = _a.offers;
    var offersWithActions = offers.map(function (offerProps) { return (__assign({}, offerProps, { onBuyClick: onBuyClick })); });
    return (React.createElement(ModalOverlay, { opacityType: TypeOverlayOpacity.Dark },
        React.createElement(Shop, { offers: offersWithActions, onClose: onCloseClick })));
};
var mapState = function (state) { return ({
    offers: selectShopInterstitialOffers(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onBuyClick: function (offer, selectedProvider) {
        return dispatch(actionShopRequestPurchase(offer, selectedProvider));
    },
    onCloseClick: function () { return dispatch(actionModalCloseAll()); },
}); };
export var MenuShopInterstitialOffer = connect(mapState, mapDispatch)(_MenuShopInterstitialOffer);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/MenuShopInterstitialOffer.tsx
// module id = 2925
// module chunks = 3